<kt-portlet [class]="'kt-portlet--height-fluid'">
  <kt-portlet-body [class]="'kt-portlet__body--fit'">
    <div class="p-4" *ngIf="(lang$ | async) === 'ru'">
      <p>
        <strong>ОКО</strong> — инструмент предиктивной аналитики. Он помогает в эффективном управлении деловыми
        поездками.<br />Для вашего удобства все данные и прогнозы собраны по группам.
      </p>

      <p>В приложении:</p>

      <ul>
        <li>
          <strong>Мой навигатор</strong> — раздел с ключевыми метриками эффективности деловых поездок в вашей компании.
        </li>
        <li><strong>Сравнение</strong> — аналитика ваших показателей в сравнении с другими индустриями.</li>
        <li>
          <strong>Бюджет-помощник</strong> — интеллектуальный ассистент, который подскажет, где есть потенциал для
          экономии и спрогнозирует бюджет.
        </li>
        <li><strong>Тревел-политика</strong> — данные по тревел-нарушениям и отклонениям от вашей тревел-политики.</li>
        <li><strong>Рекомендации</strong> — советы по управлению скидками, программами лояльности и многое другое.</li>
      </ul>
    </div>

    <div class="p-4" *ngIf="(lang$ | async) === 'en'">
      <p>
        <strong>Oko</strong> is a predictive analytics tool. It helps in discussion making for effective business travel
        management.<br />
        We blend all forecasts and reports by group for your convenience.
      </p>

      <p>You will find in application:</p>

      <ul>
        <li><strong>My Navigator</strong>. It has KPI for effective business travel management in your company.</li>
        <li><strong>Benchmarking</strong>. You can compare your indicators with other industries here.</li>
        <li>
          <strong>Budget assistant</strong>. It is an intelligent advisor helping to find areas of savings and forecast
          your budget.
        </li>
        <li>
          <strong>Travel policy</strong>. It demonstrates valuations of travel policy and quality of its management.
        </li>
        <li>
          <strong>Insights</strong>. It gives recommendations in discount management and corporate programs
          achievements, etc.
        </li>
      </ul>
    </div>
  </kt-portlet-body>
</kt-portlet>
